module.exports = __webpack_public_path__ + "static/media/clarity_notification-outline-badged.cc26a8be.svg";